import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit {

  constructor() { }

  loggedIn: boolean;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// J:/Develop/Plumit Maintenance/src/app/navbar/navbar.component.ts